import { PreFilterDatatableList } from '@europrocurement/flexy-datatable';
import {
    DOSSIER_STATUS_ARCHIVED,
    DOSSIER_STATUS_AWAITING,
    DOSSIER_STATUS_DONE,
    DOSSIER_STATUS_DRAFT,
    DOSSIER_STATUS_DRAFT_CANCELLED,
    DOSSIER_STATUS_IN_PROGRESS,
    DOSSIER_STATUS_INCOMPLETE,
    DOSSIER_STATUS_READY_TO_TRANSMIT,
    DOSSIER_STATUS_SUSPENDED,
    DOSSIER_STATUS_TO_CHECK,
    DOSSIER_STATUS_TRANSMITTED_CANCELLED,
    STEP_PREPARATION,
    STEP_TRANSMITTED,
    STEP_VALIDATION,
} from '../constants';
import { USER_DEFAULT_FORMALISTE } from '../../Utilisateur/constants';

export type DossierPrefilter = {
    value: number;
    libelle: string;
    property: string;
    childsCount?: number;
};

export type MergeDuplicatedPrefiltersLibelleProps = {
    prefilters: DossierPrefilter[];
    displayCount?: boolean;
    property?: string;
};

const useDossierPreFilters = () => {
    const backPreFilter: PreFilterDatatableList = {
        label: 'Filtrer par statuts',
        items: [
            {
                label: 'Tout',
                filters: [],
            },
            {
                label: 'Urgent',
                filters: [{ field: 'critical', value: true }],
            },
            {
                label: 'Brouillon',
                filters: [{ field: 'statutId', value: DOSSIER_STATUS_DRAFT as unknown as string }],
                hidden: true,
            },
            {
                label: 'À faire',
                filters: [
                    { field: 'statutId', value: DOSSIER_STATUS_AWAITING as unknown as string },
                ],
            },
            {
                label: 'En cours',
                filters: [
                    { field: 'statutId', value: DOSSIER_STATUS_IN_PROGRESS as unknown as string },
                ],
            },
            {
                label: 'Incomplet',
                filters: [
                    { field: 'statutId', value: DOSSIER_STATUS_INCOMPLETE as unknown as string },
                ],
            },
            {
                label: 'À contrôler',
                filters: [
                    { field: 'statutId', value: DOSSIER_STATUS_TO_CHECK as unknown as string },
                ],
            },
            {
                label: 'Déposé',
                filters: [{ field: 'stepId', value: STEP_VALIDATION as unknown as string }],
            },
            {
                label: 'Non affecté',
                filters: [
                    {
                        field: 'preFilterFormalisteId',
                        value: USER_DEFAULT_FORMALISTE as unknown as string,
                    },
                ],
            },
            {
                label: 'Prêt à être déposé',
                filters: [
                    {
                        field: 'statutId',
                        value: DOSSIER_STATUS_READY_TO_TRANSMIT as unknown as string,
                    },
                ],
                hidden: true,
            },
            {
                label: 'Suspendu',
                filters: [
                    { field: 'statutId', value: DOSSIER_STATUS_SUSPENDED as unknown as string },
                ],
                hidden: true,
            },
            {
                label: 'Annulé',
                filters: [
                    {
                        field: 'statutId',
                        value: [
                            DOSSIER_STATUS_DRAFT_CANCELLED,
                            DOSSIER_STATUS_TRANSMITTED_CANCELLED,
                        ] as unknown[] as string[],
                    },
                ],
                hidden: true,
            },
            {
                label: 'Finalisé',
                filters: [{ field: 'statutId', value: DOSSIER_STATUS_DONE as unknown as string }],
                hidden: true,
            },
            {
                label: 'Archivé',
                filters: [
                    { field: 'statutId', value: DOSSIER_STATUS_ARCHIVED as unknown as string },
                ],
                hidden: true,
            },
        ],
    };

    const frontPreFilters: PreFilterDatatableList = {
        label: 'Filtrer par statuts',
        items: [
            {
                label: 'Tout',
                filters: [],
            },
            {
                label: 'Urgent',
                filters: [{ field: 'critical', value: true }],
            },
            {
                label: 'Brouillon',
                filters: [{ field: 'statutId', value: DOSSIER_STATUS_DRAFT as unknown as string }],
            },
            {
                label: 'En traitement',
                filters: [
                    {
                        field: 'stepId',
                        value: [
                            STEP_TRANSMITTED,
                            STEP_PREPARATION,
                            STEP_VALIDATION,
                        ] as unknown[] as string[],
                    },
                ],
            },
            {
                label: 'À compléter',
                filters: [
                    { field: 'statutId', value: DOSSIER_STATUS_INCOMPLETE as unknown as string },
                ],
            },
            {
                label: 'Suspendu',
                filters: [
                    { field: 'statutId', value: DOSSIER_STATUS_SUSPENDED as unknown as string },
                ],
            },
            {
                label: 'Annulé',
                filters: [
                    {
                        field: 'statutId',
                        value: [
                            DOSSIER_STATUS_DRAFT_CANCELLED,
                            DOSSIER_STATUS_TRANSMITTED_CANCELLED,
                        ] as unknown[] as string[],
                    },
                ],
            },
            {
                label: 'Finalisé',
                filters: [{ field: 'statutId', value: DOSSIER_STATUS_DONE as unknown as string }],
            },
        ],
    };

    return {
        frontPreFilters,
        backPreFilter,
    };
};

export default useDossierPreFilters;
